import { InteractionButton, ToolbarButtonGroup } from "../../lib/ui/toolbar/buttons";
export class GroupSelectButton extends InteractionButton {
    constructor() {
        super('th', 'Select Parcels in Polygon', 'groupButton', 'Parcel Select', ToolbarButtonGroup.Group);
        this.set_interaction('group');
    }
}
